/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/lms-connect',['require','jquery','marionette'],function(require) {
  'use strict';

  //////////////
  // IMPORTS //{
  //////////////

  var $ = require('jquery');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var LMSConnect = Marionette.Object.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    API_FRAME: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ////console.log('LMSConnect::init');

      this.API_FRAME = null;

      $('body').on('beforeunload', this.cleanup);
    },

    connect: function(options)
    {
      ////console.log('LMSConnect::connect');

      if (window.opener || window.self !== window.parent || options.settings.bookmarking === 'lms') // possible lms, install api frame
      {
        console.warn('Possible LMS Detected. Installing API Frame.');
        this.installAPI(options);
      }
      else // no lms, proceed as usual
      {
        console.warn('No LMS Detected.');
        this.ready();
      }
    },

    installAPI: function(options)
    {
      // setup listener for LMS API
      $(document).on('lms.api.ready', $.proxy(this.ready, this));

      // check for dummy lms
      var dummy = (window.location.search.indexOf('dummy') !== -1);

      this.API_FRAME = this.buildFrame({ dummy: dummy });

      $('body').append(this.API_FRAME);
    },

    buildFrame: function(options)
    {
      options = options || { };

      // set API source
      var source = options.dummy ? '../_dummywrapper.html' : '../scormdriver/indexAPI.html';

      // pass query string
      source += window.location.search;

      var frame = $('<iframe name="API_FRAME" frameBorder="0" style="display:none;">');
      frame.on('error', $.proxy(this.connectionError, this));
      frame.attr('src', source);

      return frame;
    },

    connectionError: function(e)
    {
      console.warn('LMS failed to connect!');
      this.API_FRAME.remove();
    },

    cleanup: function()
    {
      if (this.API_FRAME && this.API_FRAME.contentWindow)
        this.API_FRAME.contentWindow.CommitData();
    },

    ready: function()
    {
      this.triggerMethod('ready', this);
    }

  /*****************************************************************************************************************///}

  });

  return new LMSConnect();

});

